// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"noData_noDataContainer__2Zrip","lottieContainer":"noData_lottieContainer__ypMCU"};